// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createSlice } from "@reduxjs/toolkit";
import { sortElectionList } from "@sequentech/ui-core";
var initialState = {};
export var electionsSlice = createSlice({
    name: "elections",
    initialState: initialState,
    reducers: {
        setElection: function (state, action) {
            state[action.payload.id] = action.payload;
            return state;
        },
    },
});
export var setElection = electionsSlice.actions.setElection;
export var selectElectionIds = function (state) {
    var _a, _b;
    return sortElectionList(Object.values(state.elections), (_b = (_a = Object.values(state.electionEvent)[0]) === null || _a === void 0 ? void 0 : _a.presentation) === null || _b === void 0 ? void 0 : _b.elections_order).map(function (election) { return election.id; });
};
export var selectElectionById = function (electionId) { return function (state) {
    return state.elections[electionId];
}; };
export default electionsSlice.reducer;
